import { Toast } from "antd-mobile";
import useGlobal from "./useGlobal";
import {handlerWalletTxError} from '../utils/utils'

import BigNumber from 'bignumber.js'
export default function useTransaction({intl}) {
  const { showLoading, closeLoading } = useGlobal();
  const sendTransaction = async (
    balanceFn,
    price,
    allowanceFn,
    setAllowanceFn,
    fn,
    noWaiting = false
  ) => {
    try {

      showLoading(intl.formatMessage({id: 'components.transaction.trading', defaultMessage:'交易中...'}));
      // showLoading(intl.formatMessage({id: 'components.transaction.authorization', defaultMessage:'查询授权情况...'}));
      const allowance = await allowanceFn();
      console.log("授权", allowance);
      if (!allowance) {
        showLoading(intl.formatMessage({id: 'components.transaction.authorizating', defaultMessage:'授权中...'}));
        await setAllowanceFn();
      }

      // showLoading(intl.formatMessage({id: 'components.transaction.query_balance', defaultMessage:'查询余额中...'}));
      const balance = await balanceFn();
      const balanceNumber = new BigNumber(balance)
      const priceNumber = new BigNumber(price)
      console.log("balance", balance,balanceNumber,price);
      if (balanceNumber.lt(priceNumber)) {
        console.log("余额不足");
       
        throw new Error(intl.formatMessage({id: 'components.transaction.insufficient_funds', defaultMessage:'余额不足'}));
        return
      }
      

      let tx = await fn();
      if(!noWaiting) {
        showLoading(intl.formatMessage({id: 'components.transaction.waiting', defaultMessage:'等待交易上链中...'}) );
        await tx.wait(2);
      }
     
      return;
    } catch (e) {
      closeLoading();

      let reason = handlerWalletTxError(e,intl)
      Toast.show({
        content: intl.formatMessage({id: 'components.transaction.fail', defaultMessage:'交易失败:'}) + reason,
        icon: "fail",
      });
      return Promise.reject(e);
    }
  };
  return {
    sendTransaction
  };
}


